import { render } from "./ArrowLeftTop.vue?vue&type=template&id=701bccdf"
import script from "./ArrowLeftTop.vue?vue&type=script&lang=js"
export * from "./ArrowLeftTop.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__